import { HStack, Spinner, Stack, Text } from '@mybridge/ui';
import { useContext } from 'react';
import emptyDiskIll from 'v4/assets/disk/empty-disk-ill.svg';
import { DiskContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const DiskNoFilesIllustration = ({ loading = false }) => {
  const { t } = useTranslator();
  return (
    <HStack py={12} justifyContent="center" w="100%" h="100%" bg="white">
      {loading ? (
        <Spinner />
      ) : (
        <Stack alignItems="center">
          {emptyDiskIll()}
          <Text>{t('myDisk.noFilesFound') || "No files found"}</Text>
        </Stack>
      )}
    </HStack>
  );
};
